<template>
  <el-dialog title="Relatórios de Venda" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body v-loading="isLoading" width="30%">
    <el-form ref="form" size="small" label-position="top" hide-required-asterisk :show-message="false">
      
      <p>Imóveis captados entre</p>
      <el-row :gutter="16">
        <el-col :span="10">
          <el-form-item label="" prop="dataInicial">
            <el-date-picker
              v-model="dataInicial"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span=0.5>
          <p></p>
          <span>e</span>
        </el-col>
        <el-col :span="10">
          <el-form-item label="" prop="dataFinal">
            <el-date-picker
              v-model="dataFinal"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="Corretor">
            <el-select
              v-model="usuario"
              :remote-method="filtrarUsuariosSelect"
              :loading="loadingUsuarios"
              @focus="filtrarUsuariosSelect"
              value-key="id"
              placeholder=""
              loading-text="Carregando usuários"
              no-data-text="Nenhum usuário encontrado"
              filterable
              clearable
              remote
              reserve-keyword
              style="width: 100%">
              <el-option
                v-for="item in usuariosDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
    <span slot="footer">
      <el-button type="primary" size="small" @click="gerar()" round class="btn-box-shadow">Gerar Relatório</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import funcoes from '../../../util/funcoes.js';

export default {
  props: {
    visibility: Boolean
  },
  data() {
    return {
      corretor: "",
      dataInicial: funcoes.primeiroDiaMes(),
      dataFinal: funcoes.ultimoDiaMes(),
      usuario: {},
      loadingUsuarios: false,
    }
  },
  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    }),

    ...mapState('vendasRelatoriosStore', {
      usuariosDisponiveis(state) { return state.usuariosDisponiveis }
    }),
  },
  methods: {
    ...mapActions([
      "showLoading",
      "hideLoading"
    ]),
  ...mapActions('vendasRelatoriosStore', [
      'gerarRelatorio',
      'listarUsuarios',
    ]),    
    gerar() {
      if(this.dataInicial.length !== 10 || this.dataFinal.length !== 10){
        this.exibirAlert('Atenção','Preencha as datas inicial e final!')
        return
      }
      let payload = {
        nome: "DESEMPENHO_CAPTACAO",
        dataInicial: this.dataInicial,
        dataFinal: this.dataFinal,
        usuario: {
          id: this.usuario.id
        }
      };

      this.showLoading();
      this.gerarRelatorio(payload)
      .then(resultado => {
        this.hideLoading();
        if (resultado.status == "SUCESSO") {
          window.open(resultado.mensagem, "_blank");
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      });
    },
    filtrarUsuariosSelect(queryString) {
      if(queryString.type && queryString.type === 'focus') { queryString = '' }
      let payload = { nome: queryString }
      this.loadingUsuarios = true;
      this.listarUsuarios(payload).then(() => {
        this.loadingUsuarios = false;
      })
    },    
    fechar() {
      this.$emit('close');
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: 'OK' });
    },    
  }
}
</script>

<style scoped>
.form-item {
    width: 100%; 
}
.select {
  font-size: 50%;
}
</style>